
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.711 18.086a.938.938 0 011.328 0L15 23.05l4.961-4.963a.939.939 0 011.328 1.328l-5.625 5.625a.938.938 0 01-1.328 0l-5.625-5.625a.936.936 0 010-1.328z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 4.688a.937.937 0 01.938.937V22.5a.938.938 0 01-1.876 0V5.625A.938.938 0 0115 4.687z","fill":"#fff"}})])
          )
        }
      }
    